import { FrameName } from "../config";
import AbstractRiverTerrainTileEntity from "./AbstractRiverTerrainTileEntity";

class River15TerrainTileEntity extends AbstractRiverTerrainTileEntity {
	public static readonly frameName = FrameName.RIVER15;
}

export default River15TerrainTileEntity;
